'use client';

import { cn } from '@/lib/utils';
import moment from 'moment';
import { useTranslations } from 'next-intl';
import Link from 'next/link';

export default function LatestNewsSlider(Prop: {moduleData: any[]}) {
  const newsItems = Prop.moduleData;
  const t = useTranslations('IndexPage');

  return (
    <div className="questrial text-[18px] flex flex-col gap-4">
      {newsItems.length > 0 && (
        <div>
          <div className="flex justify-between items-center py-4">
            <h2 className="text-[#e21736] text-[26px] font-bold leading-[40px] tracking-normal mt-[10px]  ">
              {t('latest-news')}
            </h2>
            <div>
              <Link
                prefetch={false}
                className="btn rounded-full p-4 bg-[#E21736] text-white hover:text-[#E21736] hover:bg-white hover:border hover:border-[#E21736]"
                href="/category/news/latest-news"
              >
                {t('view-all')}
              </Link>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {newsItems.map((newsItem, index) => (
              <Link
                prefetch={false}
                href={'/latest-news/' + newsItem.slug}
                key={'newsItem' + index}
              >
                <div
                  className={cn(
                    'bg-[#f8f8f8] rounded-md cursor-pointer flex flex-col gap-2 border border-[#f8f8f8]',
                    'hover:bg-[#f0f0f0] hover:border-[#f0f0f0]'
                  )}
                >
                  <img
                    className="aspect-[16/9] w-full object-cover rounded-t-md"
                    src={newsItem.thumbnail?.url}
                    alt={`${newsItem.title} thumbnail`}
                  />
                  <div className="p-2">
                    <div className="font-bold md:text-base leading-tight overflow-hidden text-[#e21736] min-h-[75px]">
                      <div className="line-clamp-3 ">{newsItem.title}</div>
                    </div>
                    <span className="text-[#333] text-[13px]">
                      {moment(newsItem.posted_at).format('YYYY-MM-DD')}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
